<template>
  <div>
    <div class="show" v-if="payload">
      <header>
        <h2>{{ payload.title }}</h2>
        <a class="eraser" href="#" title="Zavřít"></a>
      </header>
      <b>Typ akce</b>
      <br />{{ payload.description }}
      <p>
        <b>Místo konání</b>
        <br />{{ payload.city }} <br />{{ payload.street }} <br />{{
          payload.zipCode
        }}
      </p>
      <p>
        <b>Provozovatel / pořádající osoba</b>
        <br />{{ payload.operator }} <br />{{ payload.operatorStreet }} <br />{{
          payload.operatorCity
        }}
        <br />
      </p>
      <p><b>IČO: </b>{{ payload.ic }}</p>
      <p>
        <b>Typ tábora</b>
        <br />{{ payload.campType }}
      </p>
      <p>
        <b>Zásobování pitnou vodou</b>
        <br />{{ payload.waterSupply }}
      </p>
      <p>
        <b>Způsob stravování</b>
        <br />{{ payload.catering }}
      </p>
      <p>
        <b>Splnění ohlašovací povinnosti OOVZ: </b
        >{{ payload.reportingDutyFulfilled | anone }}
      </p>
      <p>
        <b>Datum poslední kontroly</b>
        <br />
        {{
          payload.lastInspectionDate != null
            ? payload.lastInspectionDate
            : "Nekontrolováno"
        }}
      </p>
      <p v-if="payload.lastInspectionDate != undefined">
        <b>Výsledek kontroly</b>
        <br />
        <img
          v-if="payload.lastInspectionSuccessful == 'T'"
          style="margin-top:5px"
          src="@/assets/smile.svg"
          width="30"
          height="30"
          alt="Zotavovací akce (aktuální sezóna)"
        />
        <img
          v-else
          style="margin-top:5px"
          src="@/assets/sad.svg"
          width="30"
          height="30"
          alt="Zotavovací akce (aktuální sezóna)"
        />
      </p>
      <h3>Termíny běhů</h3>
      <table>
        <thead>
          <tr>
            <th>Od</th>
            <th>Do</th>
            <th>Počet dětí</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(beh, index) in behy" v-bind:key="index">
            <td>{{ beh.dateFrom }}</td>
            <td>{{ beh.dateTo }}</td>
            <td style="text-align: center;">{{ beh.childrenCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail",
  props: ["payload"],
  components: {},
  data() {
    return {
      behy: []
    };
  },
  mounted() {
    this.$emit("caption", "Akce");
    this.createArrays();
  },
  watch: {
    payload: function() {
      this.createArrays();
    }
  },
  methods: {
    createArrays() {
      this.behy = this.payload.sessions;
    }
  },
  filters: {
    anone: function(value) {
      if (value == "F") {
        return "NE";
      } else {
        return "ANO";
      }
    }
  }
};
</script>

<style scoped>
th,
td {
  text-align: left !important;
  white-space: nowrap;
  overflow: hidden;
  padding: 4px;
  border: 1px solid #ddd;
}

th {
  background-color: #006622;
  color: #e7eced;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

table {
  border-collapse: collapse;
  width: 100%;
}
.contributors {
  margin-top: 4em;
  padding: 1.5em;
  padding-bottom: 0;
}

.contributors img {
  display: block;
  width: 100%;
  margin-bottom: 1.5em;
}
</style>
